import { apiJson, apiRaw } from '@/lib/http';

export interface KnowledgeItem {
  id: string;
  type: 'pdf' | 'url';
  title: string;
  description?: string;
  size?: string;
  uploadDate: string;
  url?: string;
  metadata?: Record<string, unknown>;
}

interface StoredKnowledge {
  id: string | number;
  fileName?: string;
  fileType?: string;
  createdAt?: string | number | Date;
  content?: ArrayBuffer | string;
  metadata?: Record<string, unknown>;
}

export const knowledgeService = {
  async getAll(projectId: string): Promise<KnowledgeItem[]> {
    const endpoint = `/MemoryFrontend/get-all-knowledge?projectId=${encodeURIComponent(projectId)}`;
    const files = await apiJson<StoredKnowledge[]>(endpoint, { method: 'GET' });
    
    return (files || []).map((f: StoredKnowledge) => {
      const bytes = f.content
        ? (typeof f.content === 'string'
            ? new Blob([f.content]).size
            : (f.content instanceof ArrayBuffer ? f.content.byteLength : 0))
        : 0;
      const size = bytes > 0 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : undefined;
      const isUrl = (f.fileName || '').startsWith('http://') || (f.fileName || '').startsWith('https://');
      
      return {
        id: (f.id || '').toString(),
        type: isUrl ? 'url' : 'pdf',
        title: isUrl ? (new URL(f.fileName || '').hostname) : (f.fileName || '').replace(/\.pdf$/i, ''),
        size,
        uploadDate: f.createdAt ? new Date(f.createdAt).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
        url: isUrl ? f.fileName : undefined,
        description: f.fileType,
        metadata: f.metadata
      };
    });
  },

  async ingestPdf(file: File, projectId: string, userId: string = 'user'): Promise<void> {
    const form = new FormData();
    form.append('file', file);
    form.append('userId', userId);
    form.append('projectId', projectId);
    form.append('consentFlag', 'true');
    form.append('sourceType', 'pdf');
    
    await apiRaw('/MemoryFrontend/ingest-knowledge', {
      method: 'POST',
      body: form
    });
  },

  async ingestUrl(url: string, projectId: string, userId: string = 'user'): Promise<void> {
    const form = new FormData();
    form.append('userId', userId);
    form.append('projectId', projectId);
    form.append('consentFlag', 'true');
    form.append('sourceType', 'url');
    form.append('sourceUrl', url);

    await apiRaw('/MemoryFrontend/ingest-knowledge', {
      method: 'POST',
      body: form
    });
  },

  async delete(id: string): Promise<void> {
    await apiRaw(`/MemoryFrontend/file/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
};

